import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TransferStatus } from '../../../core/models/app.models';

@Component({
  selector: 'app-transfer-status-select',
  template: `
    <p-dropdown [options]="options"
                [(ngModel)]="value"
                [showClear]="showClear"
                [placeholder]="placeholder"
                [styleClass]="styleClass"
                (onChange)="onChanged($event.value)"
                optionLabel="label"
                optionValue="value">

      <!-- Trigger: show selected value as a status badge -->
      <ng-template pTemplate="selectedItem">
        <span *ngIf="selectedOption"
              [class]="'status-badge ' + selectedOption.badgeClass">
          <i [class]="selectedOption.icon"></i>
          {{ selectedOption.label }}
        </span>
      </ng-template>

      <!-- Dropdown item: each option as a status badge -->
      <ng-template let-option pTemplate="item">
        <span [class]="'status-badge ' + option.badgeClass">
          <i [class]="option.icon"></i>
          {{ option.label }}
        </span>
      </ng-template>
    </p-dropdown>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TransferStatusSelectComponent),
      multi: true
    }
  ]
})
export class TransferStatusSelectComponent implements ControlValueAccessor {
  @Input() placeholder: string = 'Vyberte stav';
  @Input() showClear: boolean = true;
  @Input() styleClass: string = '';

  options = [
    {
      label: 'K vyřešení',
      value: TransferStatus.ToResolve,
      icon: 'pi pi-clock',
      badgeClass: 'status--to-resolve'
    },
    {
      label: 'Čeká se na protistranu',
      value: TransferStatus.PendingOtherSide,
      icon: 'pi pi-user',
      badgeClass: 'status--pending-other'
    },
    {
      label: 'Čeká se na podpisy',
      value: TransferStatus.PendingOurSignatures,
      icon: 'pi pi-pencil',
      badgeClass: 'status--pending-ours'
    },
    {
      label: 'Potvrzení FAČR',
      value: TransferStatus.PendingFacrConfirmation,
      icon: 'pi pi-external-link',
      badgeClass: 'status--pending-facr'
    },
    {
      label: 'Vyřešeno',
      value: TransferStatus.Resolved,
      icon: 'pi pi-check-circle',
      badgeClass: 'status--resolved'
    },
    {
      label: 'Stornováno',
      value: TransferStatus.Cancelled,
      icon: 'pi pi-times-circle',
      badgeClass: 'status--cancelled'
    },
  ];

  _value: any;

  /** Returns the full option object for the currently selected value. */
  get selectedOption() {
    return this._value != null
      ? (this.options.find(o => o.value === this._value) ?? null)
      : null;
  }

  get value() { return this._value; }
  set value(v: any) {
    if (v !== this._value) {
      this._value = v;
      this.onChange(v);
    }
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: any): void { this._value = value; }
  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }

  onChanged(val: any) {
    this.value = val;
  }
}
